const CARD_MARGIN = 16;
const CARD_GAP = 12;
const HOLE_PAD = 10;

export function holeFromRect(rect, pad = HOLE_PAD) {
  if (!rect) return null;
  const top = Math.max(0, rect.top - pad);
  const left = Math.max(0, rect.left - pad);
  return {
    top,
    left,
    width: Math.max(0, rect.width + pad * 2),
    height: Math.max(0, rect.height + pad * 2),
  };
}

function fits(top, left, cardW, cardH, vw, vh, margin) {
  return top >= margin && left >= margin && top + cardH <= vh - margin && left + cardW <= vw - margin;
}

function overlapsHole(top, left, cardW, cardH, hole, gap) {
  return (
    left < hole.left + hole.width + gap &&
    left + cardW > hole.left - gap &&
    top < hole.top + hole.height + gap &&
    top + cardH > hole.top - gap
  );
}

/**
 * Put the tour card next to the hole, never on top of it.
 * Prefers below, then above, then right, then left.
 */
export function placeTourCard({
  hole,
  vw,
  vh,
  cardW = 352,
  cardH = 220,
  gap = CARD_GAP,
  margin = CARD_MARGIN,
}) {
  if (!hole) {
    return {
      top: margin,
      left: margin,
      placement: 'center',
    };
  }

  const clampLeft = (left) => Math.max(margin, Math.min(left, Math.max(margin, vw - cardW - margin)));
  const clampTop = (top) => Math.max(margin, Math.min(top, Math.max(margin, vh - cardH - margin)));
  const alignedLeft = clampLeft(hole.left);
  const alignedTop = clampTop(hole.top);

  const below = { top: hole.top + hole.height + gap, left: alignedLeft, placement: 'bottom' };
  const above = { top: hole.top - gap - cardH, left: alignedLeft, placement: 'top' };
  const right = { top: alignedTop, left: hole.left + hole.width + gap, placement: 'right' };
  const left = { top: alignedTop, left: hole.left - gap - cardW, placement: 'left' };
  const headerish = hole.top < 140;
  const candidates = headerish
    ? [right, left, below, above]
    : [below, above, right, left];

  const pick = candidates.find(
    (row) =>
      fits(row.top, row.left, cardW, cardH, vw, vh, margin) &&
      !overlapsHole(row.top, row.left, cardW, cardH, hole, 4)
  );
  if (pick) return pick;

  return {
    top: clampTop(hole.top + hole.height + gap),
    left: alignedLeft,
    placement: 'bottom',
  };
}

export function stepUnlocksTarget(step, missing = false) {
  if (!step || missing) return false;
  return Boolean(step.waitForPathPrefix);
}
